import "react-toastify/dist/ReactToastify.css";
import AssessmentDiscussionDraftChart from "../../components/Common/Charts/AssessmentDiscussionDraftChart";
import Highcharts from "highcharts";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import OverView from "./OverView";
import PlotBarChart from "../../components/Common/Charts/PlotBarChart";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "reactstrap";

import {
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};

// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};

// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

const Dashboard = () => {
  document.title = 'Linc Quality Hub';

  // State for dropdowns and selected items
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false); // New state for term dropdown
  const [unitDropdownOpen, setunitDropdownOpen] = useState(false); // New state for term dropdown

  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [selectedUnits, setSelectedUnit] = useState(new Set()); // New state for selected terms
  const [appliedUnit, setAppliedUnit] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms

  // State for fetched data
  const [universities, setUniversities] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]); // To store timeline terms
  const [timelineUnit, setTimelineUnit] = useState([]); // To store timeline terms
  const [timelinePrograms, setTimelinePrograms] = useState([]);
  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');

  const [metricsDataTable, setmetricsDataTable] = useState(null); // State to store metrics data
  const [metricsDataUserPannel, setmetricsDataUserPannel] = useState(null); // State to store metrics data
  const [metricsData, setMetricsData] = useState(null);
  const [chartOptions, setChartOptions] = useState({});
  const [loading, setLoading] = useState(true); // New loading state
  const [loadingFilter, setLoadingFilters] = useState(false);

  const [payload, setpayload] = useState(null);

  const [Call_performance_response, setCall_performance_response] =
    useState(null);
  const [webinar_performance_response, setwebinar_performance_response] =
    useState(null);
  const [resetTrigger, setResetTrigger] = useState(0);

  //load filters in session stoarage
  //load filters in session stoarage
  useEffect(() => {
    // setLoading(true);
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedPrograms(loadFromSessionStorage('appliedPrograms'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelinesmetrics'));
    setAppliedTerms(loadFromSessionStorage('appliedTermsmetrics'));

    // Handle teacherid directly if passed from another page
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));
    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedTimelines(loadFromSessionStorage('selectedTimelinesmetrics'));
    setSelectedTerms(loadFromSessionStorage('selectedTermsmetrics'));

    // setLoading(false);
  }, []);

  //social source

  const fetchDatametrics = async () => {
    try {
      if (
        appliedUniversities.size === 0 &&
        appliedPrograms.size === 0 &&
        appliedTimelines.size === 0 &&
        appliedTerms.size === 0
      ) {
        console.warn('No filters applied; skipping API call.');
        return;
      }

      setLoading(true);

      const payload = {
        university:
          appliedUniversities.size > 0 ? Array.from(appliedUniversities) : null,
        program: appliedPrograms.size > 0 ? Array.from(appliedPrograms) : null,
        year: appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
        term: appliedTerms.size > 0 ? Array.from(appliedTerms) : null,
        // unit: selectedUnits.size > 0 ? Array.from(selectedUnits) : null,
      };
      // const response = await axios.post(
      //   process.env.REACT_APP_API_BASE_URL + 'metrics/',
      //   payload,
      // );
      setpayload(payload);
      const config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      const [
        response,
        call_performance_response,
        webinar_performance_response,
      ] = await Promise.all([
        axios.post(process.env.REACT_APP_API_BASE_URL + 'metrics/', payload, config),

        axios.post(process.env.REACT_APP_API_BASE_URL + 'metrics/', {
          ...payload,
          mode: 'call_performance',
        }, config
        ),
        axios.post(process.env.REACT_APP_API_BASE_URL + 'metrics/', {
          ...payload,
          mode: 'webinar_performance',
        }, config),
      ]);

      setCall_performance_response(call_performance_response);
      const avgScore =
        call_performance_response?.avg_session_quality_score ?? 0;

      setCallQualityChartOptions(prev => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: [Number(avgScore.toFixed(1))], // single dynamic value
          },
        ],
      }));

      console.warn(
        'webinar_performance_response',
        webinar_performance_response,
      );
      setwebinar_performance_response(webinar_performance_response);
      if (response.status === 500) {
        // toast.error('No class Rooms Available')
        resetData();
        return;
      }

      //metriics card

      if (response && response.data && response.data.length > 0) {
        const responseData = response.data[0];

        const data = responseData.assessment_grading_score;
        setAssessmentData({
          avg_score: responseData.assessment_grading_score || 0,
        });
        // Safely access and map the response data
        const metricsCard = {
          totalStudentsClassroomUnit:
            responseData?.Total_student_classroom_unit || 0,
          totalNewStudents:
            responseData?.total_student_classroom_new_students || 0,
          totalUniqueStudents: responseData?.Total_students_unique || 0,
          totalTeachersClassrooms: responseData?.Total_teachers_classrooms || 0,
          assessmentScore: responseData?.Assessment_score_lf || 0,
          percentageEngagedOnPhoneOrVideo:
            responseData?.['Percentage_of_std_engaged_on_phone_or_video'] ||
            '0%',
          percentageEngagedOneOnOne:
            responseData?.['Percentage_of_Students_Engaged_1-1'] || '0%',
          averageTimePerCall: responseData?.Average_time_per_call || '0 mins',
          averageTimePerStudent:
            responseData?.Average_time_per_student || '0 mins',
          averageMessagesPerStudent:
            responseData?.Average_message_per_student || 0,
          averageSatisfactionScore: responseData?.Avg_Satisfaction_score || {
            mid_term: 0,
            end_term: 0,
          },
          audioVideoDurationCount:
            responseData?.Audio_video_duration_count || 0,
          totalMessages: responseData?.Total_messages || 0,
          messageResponsiveness: responseData?.Message_responsiveness || 0,
          unitCompletionRatePercent:
            responseData?.unit_completion_rate_ || '0%',
          engagementMetricsTable:
            responseData?.['Engagement metrics table'] || [],
          total_sessions: responseData?.total_sessions || 0,
          NumberofGroupSessions: responseData?.total_group_sessions || 0
        };

        setmetricsDataUserPannel(metricsCard); // Update the state with the structured metrics
        //// console.log('Metrics Data:', metrics); // Log the response data for verification

        const audioVideoDurationCount =
          responseData?.Audio_video_duration_count || {
            audio_call_time: '0 mins',
            audio_call_successful_count: 0,
            video_call_time: '0 mins',
            video_call_successful_count: 0,
          };

        const audioDuration =
          parseInt(audioVideoDurationCount.audio_call_time.total_duration) || 0; // Convert duration to number
        const audioSuccessful =
          audioVideoDurationCount.audio_call_successful_count || 0;
        const videoDuration =
          parseInt(audioVideoDurationCount.video_call_time.total_duration) || 0; // Convert duration to number
        const videoSuccessful =
          audioVideoDurationCount.video_call_successful_count || 0;
        const metricsTable = {
          engagementMetricsTable: responseData?.Engagement_metrics_table || [],
        };

        setmetricsDataTable(metricsTable);
        // Update metrics data
        const metrics = {
          averageSatisfactionScore: responseData?.Avg_Satisfaction_score || {
            mid_term: 0,
            end_term: 0,
          },
          audioVideoDurationCount,
          totalMessages: responseData?.Total_messages || {
            messages_sent: 0,
            messages_received: 0,
          },
          messageResponsiveness: responseData?.Message_responsiveness || {
            '0-1hrs': '0%',
            '1-2hrs': '0%',
            '2-3hrs': '0%',
            '2-6hrs': '0%',
            'above_6_hrs': '0%',
            'not_responded': '0%',
          },
          studentsEngagedPercentage:
            responseData?.studends_engaged_percentage || {
              new: '0%',
              returning: '0%',
              total: '0%',
            },
          censusDropRatePercentage:
            responseData?.census_drop_rate_percentage || {
              new: '0%',
              returning: '0%',
              total: '0%',
            },
          unitCompletionRatePercent:
            responseData?.unit_completion_rate_percentage || {
              new: '0%',
              returning: '0%',
              total: '0%',
            },
        };

        setMetricsData(metrics); // Update the state with the structured metrics
        setChartOptions(
          combinedChartOptions(
            audioDuration,
            audioSuccessful,
            videoDuration,
            videoSuccessful,
          ),
        ); // Set updated chart options
      }
      //new code refresh
      else {
        resetData();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // toast.error('Please Try Another Filters')

      resetData();
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };


  const resetData = () => {
    // Reset all data to initial state
    setResetTrigger((prev) => prev + 1); // trigger child reset

    setCall_performance_response(null);
    setAssessmentData({
      unit_names: [],
      avg_score: [],
    });
    setmetricsDataUserPannel({
      totalStudentsClassroomUnit: 0,
      totalNewStudents: 0,
      totalUniqueStudents: 0,
      totalTeachersClassrooms: 0,
      percentageEngagedOnPhoneOrVideo: '0%',
      percentageEngagedOneOnOne: '0%',
      averageTimePerCall: '0 mins',
      averageTimePerStudent: '0 mins',
      averageMessagesPerStudent: 0,
      averageSatisfactionScore: { mid_term: 0, end_term: 0 },
      audioVideoDurationCount: 0,
      totalMessages: 0,
      messageResponsiveness: 0,
      unitCompletionRatePercent: '0%',
      engagementMetricsTable: [],
      total_sessions: 0,
      NumberofGroupSessions: 0
    });
    setmetricsDataTable({ engagementMetricsTable: [] });
    setMetricsData({
      averageSatisfactionScore: { mid_term: 0, end_term: 0 },
      audioVideoDurationCount: {
        audio_call_time: { total_duration: 0 },
        audio_call_successful_count: 0,
        video_call_time: { total_duration: 0 },
        video_call_successful_count: 0,
      },
      totalMessages: { messages_sent: 0, messages_received: 0 },
      messageResponsiveness: {
        '0-1hrs': '0%',
        '1-2hrs': '0%',
        '2-3hrs': '0%',
        '2-6hrs': '0%',
        'above_6_hrs': '0%',
        'not_responded': '0%',
      },
      studentsEngagedPercentage: { new: '0%', returning: '0%', total: '0%' },
      censusDropRatePercentage: { new: '0%', returning: '0%', total: '0%' },
      unitCompletionRatePercent: { new: '0%', returning: '0%', total: '0%' },
    });
  };
  useEffect(() => {
    fetchDatametrics();
  }, [appliedPrograms, appliedUniversities, appliedTerms, appliedTimelines]);

  const clusteredColumnChartUnitCompletion = (data) => ({
    chart: {
      type: 'column', // Using column type for a clustered chart
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [''], // Only one group: "Unit Completion Rate"
      title: {
        text: null,
      },
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100, // Set max to 100 for percentage
      tickInterval: 20,
      title: {
        text: 'Unit Completion Rate (%)',
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Append percentage sign
        },
      },
    },
    plotOptions: {
      column: {
        grouping: true, // Ensure columns are grouped
        borderWidth: 0, // Remove border around columns
        pointWidth: 10, // Set point width to 10
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Set label text color (black)
          style: {
            fontSize: '10px', // Set font size for the labels
            fontWeight: 'bold', // Optional: make labels bold
          },
          verticalAlign: 'middle', // Align label vertically in the middle
          align: 'left', // Position label to the right of the column
          crop: false, // Ensure labels are visible even if they are outside the plot area
          overflow: 'none', // Do not hide labels that overflow
          x: 10, // Add some offset to the right (adjust as needed)
        },
      },
    },
    series: [
      {
        name: 'New Students',
        data: [parseInt(data?.unitCompletionRatePercent.new) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#A2CCFA'],
            [0.5, '#CEDDFA'],
            [1, '#F2F5FC'],
          ],
        },
        pointPadding: 0.1,
      },
      {
        name: 'Returning Students',
        data: [parseInt(data?.unitCompletionRatePercent.returning) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#F9C78D'],
            [0.5, '#FFE9D7'],
            [1, '#FFF3E7'],
          ],
        },
        pointPadding: 0.1,
      },
      {
        name: 'All Students',
        data: [parseInt(data?.unitCompletionRatePercent.total) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#FF9B9B'],
            [0.5, '#FDD8D8'],
            [1, '#FDE9EB'],
          ],
        },
        pointPadding: 0.1,
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Unit Completion Rate (%)',
        },
      },
    },
  });

  const clusteredColumnChartCensus = (data) => ({
    chart: {
      type: 'column', // Using column type for a clustered chart
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [''], // Only one group: "Census Drop Rate (%)"
      title: {
        text: null,
      },
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100,
      tickInterval: 20,
      title: {
        text: 'Melt Rate(%)',
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Append percentage sign
        },
      },
    },
    plotOptions: {
      column: {
        grouping: true, // Ensure columns are grouped
        borderWidth: 0, // Remove border around columns
        pointWidth: 10, // Set point width to 10
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Set label text color to black
          style: {
            fontSize: '10px', // Set font size for the labels
            fontWeight: 'bold', // Make labels bold
          },
          verticalAlign: 'middle', // Align vertically in the middle
          align: 'left', // Position the labels to the right of the bars
          crop: false, // Ensure labels are visible even if they are outside the plot area
          overflow: 'none', // Do not hide labels that overflow
          x: 10, // Offset the labels to the right (adjust if necessary)
        },
      },
    },
    series: [
      {
        name: 'New Students',
        data: [parseInt(data?.censusDropRatePercentage.new) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#F9C78D'],
            [0.5, '#FFE9D7'],
            [1, '#FFF3E7'],
          ],
        },
        pointPadding: 0.1,
      },
      {
        name: 'Returning Students',
        data: [parseInt(data?.censusDropRatePercentage.returning) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#A2CCFA'],
            [0.5, '#CEDDFA'],
            [1, '#F2F5FC'],
          ],
        },
        pointPadding: 0.1,
      },
      {
        name: 'All Students',
        data: [parseInt(data?.censusDropRatePercentage.total) || 0],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, '#FF9B9B'],
            [0.5, '#FDD8D8'],
            [1, '#FDE9EB'],
          ],
        },
        pointPadding: 0.1,
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Census Melt Rate (%) ',
        },
      },
    },
  });




  const combinedChartOptions = (
    audioDuration,
    audioSuccessful,
    videoDuration,
    videoSuccessful,
  ) => ({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      marginTop: 40, // Adjust this value to increase or decrease space
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['Audio', 'Video'],
      title: {
        text: 'Call Type',
      },
    },
    yAxis: {
      title: {
        text: 'Values',
      },
      min: 0,
      max:
        Math.max(
          audioDuration,
          videoDuration,
          audioSuccessful,
          videoSuccessful,
        ) + 10,
    },
    series: [
      {
        name: 'Total Call Duration (min)',
        type: 'column',
        data: [audioDuration, videoDuration],
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E1EAF9'],
            [1, '#B5D0FB'],
          ],
        },
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} mins`; // Show total duration in mins
          },
        },
      },
      {
        name: 'Number of Successful Calls',
        type: 'line',
        data: [audioSuccessful, videoSuccessful],
        color: '#FF9FA2',
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} successful`; // Show successful call count
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Successful Calls and Duration',
        },
        // Include data table
        data: {
          table: {
            rows: [
              ['Call Type', 'Total Duration (min)', 'Successful Calls'],
              ['Audio', audioDuration, audioSuccessful],
              ['Video', videoDuration, videoSuccessful],
            ],
          },
        },
      },
    },
  });

  const [callQualityChartOptions, setCallQualityChartOptions] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [''],   // ✅ single category
      title: {
        text: '',
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Avg. Quality Score (%)',
      },
      labels: {
        format: '{value}%',   // ✅ ADD THIS
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: 'Average Call Quality Score',
        data: [0],               // ✅ single value
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'],
            [1, '#B7B8F9'],
          ],
        },
        dataLabels: {
          enabled: true,
          format: '{y}%',
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
  });

  const barChartOptions = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['Mid-Term', 'End Term'],
      title: {
        text: 'Term',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Average Student Satisfaction',
      },
      labels: {
        formatter: function () {
          return this.value; // Format the labels
        },
      },
    },
    series: [
      {
        name: 'Satisfaction Score',
        colorByPoint: true, // Apply different colors for each point
        data: [
          {
            y: metricsData ? metricsData.averageSatisfactionScore.mid_term : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
              stops: [
                [0, 'rgba(255,232,214,1)'], // Start color
                [1, 'rgba(255,200,170,1)'], // End color
              ],
            },
          },
          {
            y: metricsData ? metricsData.averageSatisfactionScore.end_term : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
              stops: [
                [0, 'rgba(255,232,214,1)'], // Start color
                [1, 'rgba(255,180,150,1)'], // End color
              ],
            },
          },
        ],
        pointWidth: 10, // Adjusted to number instead of string
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{point.y}', // Display the y value
          style: {
            fontWeight: 'bold',
            color: 'black', // Customize label color
          },
        },
      },
    ],
    legend: {
      enabled: false, // Optionally disable the legend if it's not needed
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Average Student Satisfaction',
        },
      },
    },
  };
  const [assessmentData, setAssessmentData] = useState({
    avg_score: 0, // single value now
  });

  console.log("assessmentData", assessmentData.avg_score)

  // Chart configuration
  const barChartAssessmentScore = (assessmentData) => ({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      spacingTop: 30,
    },
    title: {
      text: '',

    },
    xAxis: {
      categories: ['Average'], // only one bar
      title: { text: null },
    },
    yAxis: {
      min: 0,
      max: 100, // max 100 for percentage
      title: { text: 'Score (%)' },
      labels: {
        formatter: function () {
          return this.value + '%'; // show % on y-axis
        },
      },
    },
    legend: { enabled: false },
    plotOptions: {
      column: {
        borderWidth: 0,
        pointWidth: 10, // set bar width to 10
        dataLabels: {
          enabled: true,
          color: 'black',
          style: { fontSize: '12px', fontWeight: 'bold' },
          verticalAlign: 'bottom',
          crop: false,
          overflow: 'none',
          formatter: function () {
            return this.y + '%'; // show % on data label
          },
        },
      },
    },
    series: [
      {
        name: 'Average Score',
        data: [assessmentData.avg_score || 0], // single value
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, '#A2CCFA'],
            [0.5, '#CEDDFA'],
            [1, '#F2F5FC'],
          ],
        },
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>', // tooltip in %
    },
    credits: { enabled: false },
    exporting: { enabled: true },
  });


  const donutChartOptions1 = {
    chart: {
      type: 'pie', // Change to pie for donut chart
      backgroundColor: 'transparent', // Optional: set background to transparent
      options3d: {
        enabled: true, // Enable 3D for donut effect
        alpha: 45, // Set the alpha angle for the 3D view
        beta: 0, // Beta angle
      },
    },
    title: {
      text: '', // Removed the title
    },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.y}%</b>', // Customize tooltip to include percentage
    },
    plotOptions: {
      pie: {
        innerSize: '90%',
        dataLabels: {
          enabled: false,
          formatter: function () {
            // Only render labels for the first point to avoid duplication
            if (this.point.index === 0) {
              return this.series.data
                .map((point) => `${point.name}: ${point.y}%`)
                .join('<br>');
            }
            return null; // Skip for other points
          },
          style: {
            fontWeight: 'bold',
            color: 'black',
            textAlign: 'center',
          },
          distance: -150, // Position labels inside the donut
        },
        size: '80%',
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
        borderWidth: 0,
      },
    },

    series: [
      {
        name: 'Message Responsivenes',
        data: [
          {
            name: 'Within 60 min',
            y: metricsData?.messageResponsiveness['0-1hrs']
              ? parseFloat(metricsData.messageResponsiveness['0-1hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#EBFFEE'],
                [1, '#A2EAB3'], // green
              ],
            },
          },
          {
            name: 'In 1-2 hrs',
            y: metricsData?.messageResponsiveness['1-2hrs']
              ? parseFloat(metricsData.messageResponsiveness['1-2hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#e6eeff'],
                [1, '#B7D0F6'], // blue
              ],
            },
          },
          // {
          //   name: 'In 2-4 hrs',
          //   y: metricsData?.messageResponsiveness["2-3hrs"] ? parseInt(metricsData.messageResponsiveness["2-3hrs"]) : 0,
          //   color: {
          //     linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
          //     stops: [
          //       [0, '#FFEFE1'],
          //       [1, '#FFE5CD'], // orange
          //     ],
          //   },
          // },
          {
            name: 'In 2-6 hrs',
            y: metricsData?.messageResponsiveness['2-6hrs']
              ? parseFloat(metricsData.messageResponsiveness['2-6hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#96bdc900'],
                [1, '#53839299'], // Dark green
              ],
            },
          },
          {
            name: 'In More than 6 hrs',
            y: metricsData?.messageResponsiveness['above_6_hrs']
              ? parseFloat(metricsData.messageResponsiveness['above_6_hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#E6EEFF'],
                [1, '#9397FF'], //  purple
              ],
            },
          },
          {
            name: 'Not Responded',
            y: metricsData?.messageResponsiveness['not_responded']
              ? parseFloat(metricsData.messageResponsiveness['not_responded'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#FFD2D2'],
                [1, '#F79496'], // red
              ],
            },
          },
        ],
      },
    ],
    legend: {
      enabled: false, // Optionally disable the legend if it's not needed
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Message Responsiveness', // Removed title from exporting options
        },
      },
    },
  };


  // const { messageResponsiveness } = metricsData;
  const { messageResponsiveness = {} } = metricsData || {};

  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      default:
        break;
    }
  };

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };

  const toggleProgramDropdown = () => setProgramDropdownOpen((prev) => !prev);
  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };

  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);

  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);

  // Handle selecting/unselecting items in dropdowns

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    let newSelection = new Set(selectedSet);
    setResetTrigger((prev) => prev + 1); // trigger child reset

    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms' ||
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    }
    // } else if (item.removename === 'removeyears' || item.removename === 'removestudyperiod') {
    //   // If the item is part of year or study period (single selection)
    //   newSelection.clear(); // Clear all previous selections
    //   // newSelection.delete(item.id);
    //   newSelection.add(item.id); // Add the new selection
    // }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setPrograms([]);
      setTimelineYears([]);
      setTimelineTerms([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setTimelineYears([]);
      setTimelineTerms([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
    }

    setSelectedSet(newSelection); // Update the selection state
    toggleDropdown(); // Close the dropdown
  };

  const handleApply = () => {
    // Check if both timelines and terms are selected
    // if (selectedTimelines.size > 0 && selectedTerms.size > 0) {
    //   toast.error("Please choose either a year or a term, not both.");
    //   return;
    // }
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a study period.');
      return;
    }
    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedUnit(new Set(selectedUnits));
    setAppliedPrograms(new Set(selectedPrograms));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesmetrics', selectedTimelines);
    saveToSessionStorage('appliedTermsmetrics', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('selectedUniversitiesmetrics', selectedUniversities);
    saveToSessionStorage('selectedTimelinesmetrics', selectedTimelines);
    saveToSessionStorage('selectedProgramsmetrics', selectedPrograms);
    saveToSessionStorage('selectedTermsmetrics', selectedTerms);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setunitDropdownOpen(false);
    setProgramDropdownOpen(false);
  };

  const user_token = localStorage.getItem('usertoken');

  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log('Sending tabs request with token:', user_token); // 🔍
      // console.log('Payload:', payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log('Tabs Response:', tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    fetchDataTabs();
  }, []);

  const fetchData = async () => {
    try {
      setLoadingFilters(true);

      // const response = await axios.get(process.env.REACT_APP_API_BASE_URL + 'filter/',);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // console.log('response', response);
      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);

  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
        milestone_number: 'Milestone 1',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  // useEffect(() => {

  //   // Call fetchData only if there are selected universities or timelines
  //   if ((selectedUniversities && selectedUniversities.size > 0) || selectedTimelines.size > 0 || selectedTerms > 0) {
  //     fetchDatawithYearUnit();
  //   }
  // }, [selectedTimelines, selectedTerms]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);
  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'metrics',
        sub_mode: 'year',
        milestone_number: 'Milestone 1',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        mode: 'metrics',
        sub_mode: 'term',
        milestone_number: 'Milestone 1',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedPrograms, selectedTimelines]);

  // const fetchDatawithYearUnit = async () => {
  //   try {
  //     const payload = {
  //       university: selectedUniversities.size > 0 ? Array.from(selectedUniversities) : null,
  //       year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
  //       term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
  //       mode: "metrics",
  //       sub_mode: "unit",

  //     };

  //     const unitResponse = await axios.post(process.env.REACT_APP_API_BASE_URL+'filter/', payload);
  //     setTimelineUnit(unitResponse.units || []);

  //   } catch (error) {

  //   }
  // };
  // // console.log("term",timelineUnit)

  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters

  const [slideIndex, setSlideIndex] = useState(0);

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };


  // Function to remove a program from the selected set

  // Function to remove a timeline from the selected set

  // Function to remove a term from the selected set
  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    setAppliedUniversities(new Set());
    setAppliedPrograms(new Set());
    setAppliedTimelines(new Set());
    setAppliedTerms(new Set());

    removeFromSessionStorage('appliedUniversitiesmetircs');
    removeFromSessionStorage('appliedProgramsmetircs');
    removeFromSessionStorage('appliedTimelinesmetrics');
    removeFromSessionStorage('appliedTermsmetrics');
    removeFromSessionStorage('selectedUniversitiesmetrics');
    removeFromSessionStorage('selectedProgramsmetrics');
    removeFromSessionStorage('selectedTimelinesmetrics');
    removeFromSessionStorage('selectedTermsmetrics');
    setPrograms([]);
    setTimelineYears([]);
    setTimelineTerms([]);
    fetchData();

    resetData();
    // fetchDatametrics();
    // Wait for state updates before calling fetchDatametrics
    //   setTimeout(() => {
    //     fetchDatametrics();
    // }, 0);
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className=" mb-2 position-relative">
            <div className={`top-filter  ${isSticky ? 'sticky-filter' : ''}`}>
              <div className="">
                {/* <div className="tab-tp-title">
                  <h3 className="bold">Overview</h3>
                </div> */}
                <div className="metrics mt-2 d-flex flex-sm-row flex-column gap-2 justify-content-between">
                  <div className="d-flex justify-content-end   gap-2">
                    {/* University Dropdown */}
                    <Dropdown
                      isOpen={universityDropdownOpen}
                      toggle={toggleUniversityDropdown}
                    >
                      <DropdownToggle
                        className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        {/* University <i className="mdi mdi-chevron-down" /> */}
                        {loadingFilter ? 'Loading' : 'University'}{' '}
                        <i className="mdi mdi=chevron-down" />
                      </DropdownToggle>
                      {!loadingFilter && (
                        <>
                          <DropdownMenu className="p-0">
                            <input
                              type="text"
                              placeholder="Search Universities"
                              className="form-control"
                              value={universitySearch}
                              onChange={(e) =>
                                handleSearchChange(e, 'university')
                              }
                            />

                            {/* "Select All" Option */}
                            <DropdownItem
                              onClick={(e) => {
                                e.stopPropagation();
                                const allSelected =
                                  selectedUniversities.size ===
                                  universities.length;
                                const newSelection = new Set();

                                if (!allSelected) {
                                  // Select all universities
                                  universities.forEach((university) =>
                                    newSelection.add(university.id),
                                  );
                                  setSelectedPrograms(new Set()); // Clear selected programs
                                  setPrograms([]); // Reset program list
                                  setSelectedTimelines(new Set());
                                  setSelectedTerms(new Set());
                                  setTimelineYears([]);
                                  setTimelineTerms([]);
                                } else {
                                  // Deselect all universities, applying the removeuniversity logic
                                  setSelectedPrograms(new Set()); // Clear selected programs
                                  setPrograms([]); // Reset program list
                                  setSelectedTimelines(new Set());
                                  setSelectedTerms(new Set());
                                  setTimelineYears([]);
                                  setTimelineTerms([]);
                                }

                                setSelectedUniversities(newSelection); // Update the selected universities set
                                toggleUniversityDropdown(); // Close the dropdown
                              }}
                            >
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={
                                    selectedUniversities.size ===
                                    universities.length
                                  } // Check if all are selected
                                  readOnly
                                />
                                <label className="form-check-label">All</label>
                              </div>
                            </DropdownItem>

                            {/* University Options */}
                            {filterUniversities(universitySearch).map(
                              (university) => (
                                <DropdownItem
                                  key={university.id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectItem(
                                      {
                                        id: university.id,
                                        name: university.university_name,
                                        removename: 'removeuniversity',
                                      },
                                      selectedUniversities,
                                      setSelectedUniversities,
                                      toggleUniversityDropdown,
                                    );
                                  }}
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={isItemSelected(
                                        university.id,
                                        selectedUniversities,
                                      )}
                                      readOnly
                                    />
                                    <label className="form-check-label">
                                      {university.university_name}
                                    </label>
                                  </div>
                                </DropdownItem>
                              ),
                            )}
                          </DropdownMenu>
                        </>
                      )}
                    </Dropdown>

                    {/* Programs Dropdown */}
                    <Dropdown
                      isOpen={programDropdownOpen}
                      toggle={toggleProgramDropdown}
                    >
                      <DropdownToggle
                        disabled={programs.length === 0}
                        className={`btn program-bg ${programs.length > 0 ? '' : 'disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Programs <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Programs"
                          className="form-control"
                          value={programSearch}
                          onChange={(e) => handleSearchChange(e, 'program')}
                        />

                        {/* All Option */}
                        <DropdownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            const allSelected =
                              selectedPrograms.size === programs.length;
                            const newSelection = new Set();
                            if (!allSelected) {
                              programs.forEach(([programId]) =>
                                newSelection.add(programId),
                              );
                              setSelectedTimelines(new Set());
                              setSelectedTerms(new Set());
                              setTimelineYears([]);
                              setTimelineTerms([]);
                            } else {
                              //deselect
                              setSelectedTimelines(new Set());
                              setSelectedTerms(new Set());

                              setTimelineYears([]);
                              setTimelineTerms([]);
                            }
                            setSelectedPrograms(newSelection);
                            toggleProgramDropdown();
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                selectedPrograms.size === programs.length
                              }
                              readOnly
                            />
                            <label className="form-check-label">All</label>
                          </div>
                        </DropdownItem>

                        {/* Program Options */}
                        {filterPrograms(programSearch).map(
                          ([programId, programName]) => (
                            <DropdownItem
                              key={programId}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelectItem(
                                  {
                                    id: programId,
                                    name: programName,
                                    removename: 'removeprograms',
                                  },
                                  selectedPrograms,
                                  setSelectedPrograms,
                                  toggleProgramDropdown,
                                );
                              }}
                            >
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isItemSelected(
                                    programId,
                                    selectedPrograms,
                                  )}
                                  readOnly
                                />
                                <label className="form-check-label">
                                  {programName}
                                </label>
                              </div>
                            </DropdownItem>
                          ),
                        )}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="d-flex justify-content-end flex-wrap gap-2">
                    {/* Timeline Dropdown */}
                    <Dropdown
                      isOpen={timelineDropdownOpen}
                      toggle={toggleTimelineDropdown}
                    >
                      <DropdownToggle
                        disabled={timelineYears.length === 0}
                        className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Year <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Year"
                          className="form-control"
                          value={timelineSearch}
                          onChange={(e) => handleSearchChange(e, 'timeline')}
                        />
                        {/* "Select All" Option */}
                        <DropdownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            const allSelected =
                              selectedTimelines.size === timelineYears.length;
                            const newSelection = new Set();

                            if (!allSelected) {
                              // Select all years
                              timelineYears.forEach((year) =>
                                newSelection.add(year),
                              );
                              setSelectedTerms(new Set());
                              setTimelineTerms([]);
                            } else {
                              setSelectedTerms(new Set());
                              setTimelineTerms([]);
                            }
                            setSelectedTimelines(newSelection);
                            toggleTimelineDropdown();
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                selectedTimelines.size === timelineYears.length
                              }
                              readOnly
                            />
                            <label className="form-check-label">All</label>
                          </div>
                        </DropdownItem>
                        {/* {timelineYears.map((year, index) => ( */}
                        {filterTimeline(timelineSearch).map((year, index) => (
                          <DropdownItem
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: year,
                                  name: year,
                                  removename: 'removeyears',
                                },
                                selectedTimelines,
                                setSelectedTimelines,
                                toggleTimelineDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  year,
                                  selectedTimelines,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">{year}</label>
                            </div>
                          </DropdownItem>
                        ))}

                        {/* ))} */}
                      </DropdownMenu>
                    </Dropdown>

                    {/* Timeline Term Dropdown */}
                    <Dropdown
                      isOpen={termDropdownOpen}
                      toggle={toggleTermDropdown}
                    >
                      <DropdownToggle
                        disabled={timelineTerms.length === 0}
                        className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Study Period <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Study Period"
                          className="form-control"
                          value={termSearch}
                          onChange={(e) => handleSearchChange(e, 'term')}
                        />
                        {/* "Select All" Option */}
                        <DropdownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            const allSelected =
                              selectedTerms.size === timelineTerms.length;
                            const newSelection = new Set();

                            if (!allSelected) {
                              // Select all terms
                              timelineTerms.forEach((term) =>
                                newSelection.add(term),
                              );
                            }
                            setSelectedTerms(newSelection);
                            toggleTermDropdown();
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                selectedTerms.size === timelineTerms.length
                              }
                              readOnly
                            />
                            <label className="form-check-label">All</label>
                          </div>
                        </DropdownItem>
                        {/* {timelineTerms.map((term, index) => ( */}
                        {filterTerms(termSearch).map((term, index) => (
                          <DropdownItem
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: term,
                                  name: term,
                                  removename: 'removestudyperiod',
                                },
                                selectedTerms,
                                setSelectedTerms,
                                toggleTermDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isTermSelected(term, selectedTerms)}
                                readOnly
                              />
                              <label className="form-check-label">{term}</label>
                            </div>
                          </DropdownItem>
                        ))}

                        {/* ))} */}
                      </DropdownMenu>
                    </Dropdown>

                    <button
                      type="button"
                      className="btn btn-primary border-0 py-1 px-3 me-1"
                      onClick={handleApply}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              {/* normal nav filter show */}
              <div className="filters-show">
                <div className="selected-filters">
                  {showScrollButtons && (
                    <button
                      className="slider-button slider-button-left"
                      onClick={handleLeftClick}
                    >
                      <i className="ri-arrow-left-s-line"></i>
                    </button>
                  )}

                  <div
                    className="filter-summary"
                    ref={filterSummaryRef}
                    onMouseDown={startDrag}
                    onMouseMove={handleMouseMove}
                    onMouseUp={stopDrag}
                    onMouseLeave={stopDrag}
                    onTouchStart={startDrag} // Touch equivalent of onMouseDown
                    onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                    onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                  >
                    {selectedUniversities.size > 0 && (
                      <div
                        className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                          }`}
                      >
                        {Array.from(selectedUniversities).map(
                          (universityId) => {
                            const university = universities.find(
                              (u) => u.id === universityId,
                            );
                            return university ? (
                              <p
                                key={universityId}
                                className="filter-tag university"
                              >
                                {university.university_name}{' '}
                                {/* <i
                                className="ri-close-line"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeUniversity(universityId)}
                              ></i> */}
                              </p>
                            ) : null;
                          },
                        )}
                      </div>
                    )}

                    {selectedPrograms.size > 0 && (
                      <div className="filter-item">
                        {Array.from(selectedPrograms).map((programId) => {
                          const program = programs.find(
                            ([id]) => id === programId,
                          );
                          return program ? (
                            <p key={programId} className="filter-tag programs">
                              {program[1]}
                            </p>
                          ) : null;
                        })}
                      </div>
                    )}

                    {selectedTimelines.size > 0 && (
                      <div className="filter-item">
                        {Array.from(selectedTimelines).map((year, index) => (
                          <p key={index} className="filter-tag year">
                            {year}
                          </p>
                        ))}
                      </div>
                    )}

                    {selectedTerms.size > 0 && (
                      <div className="filter-item">
                        {Array.from(selectedTerms).map((term, index) => (
                          <p key={index} className="filter-tag stu-period">
                            {term}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>

                  {showScrollButtons && (
                    <button
                      className="slider-button slider-button-right"
                      onClick={handleRightClick}
                    >
                      <i className="ri-arrow-right-s-line"></i>
                    </button>
                  )}
                </div>
                <div className="">
                  {hasSelections && (
                    <button
                      type="button"
                      className="clear-all-btn me-1"
                      onClick={clearAllSelections}
                    >
                      <i class="ri-close-fill"></i> Clear All
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="tab-tp-title">
            <h3 className="bold">Overview</h3>
          </div>

          <div className="">
            <div>
              <Card className="mb-2">
                <CardBody>
                  <div className="tab-head d-flex justify-content-between  mb-2">
                    <h5 className="bold">Enrolment Details</h5>
                    {/* <CSVLink data={csvData} filename="metrics_summary.csv" className="btn" style={{border:'1px solid #ddd', borderRadius:'6px', padding:'4px 8px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                            </svg>
                          </CSVLink> */}
                  </div>
                  {loading ? ( // Show loader while loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <div>
                      <Row className="g-2">
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="minty-gradient border-green mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/students')} style={{ cursor: 'pointer' }}> */}
                          <Card className="minty-gradient border-green mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Total Unit Enrolments
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.totalStudentsClassroomUnit
                                      : '0'}
                                  </h4>
                                  {/* <CSVLink data={[{ "Student Enrolments": metricsDataUserPannel ? metricsDataUserPannel.totalStudentsClassroomUnit : "Loading..." }]} filename="total_students_class_rooms.csv" className="btn btn-link">Download</CSVLink> */}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="sky-gradient border-sky mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Unique Students Enrolled
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.totalUniqueStudents
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="peachy-gradient border-red mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/totalcallduration')} style={{ cursor: 'pointer' }} > */}
                          <Card className="peachy-gradient border-red mb-0 h-100 ">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    {' '}
                                    New Students Enrolled
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.totalNewStudents
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="lavender-gradient border-lavender mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Teachers Deployed
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.totalTeachersClassrooms
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="minty-gradient border-green mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/students')} style={{ cursor: 'pointer' }}> */}
                          <Card className="minty-gradient border-green mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Total 1-1 Sessions
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel?.total_sessions || "0"
                                      : '0'}
                                  </h4>
                                  {/* <CSVLink data={[{ "Student Enrolments": metricsDataUserPannel ? metricsDataUserPannel.totalStudentsClassroomUnit : "Loading..." }]} filename="total_students_class_rooms.csv" className="btn btn-link">Download</CSVLink> */}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="peachy-gradient border-red mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/totalcallduration')} style={{ cursor: 'pointer' }} > */}
                          <Card className="peachy-gradient border-red mb-0 h-100 ">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    {' '}
                                    Number of Group Sessions
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.NumberofGroupSessions
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>

              <Card className="mb-2">
                <CardBody>
                  <div className="tab-head d-flex justify-content-between  mb-2">
                    <h5 className="bold">Unit Performance</h5>
                    {/* <CSVLink data={csvData} filename="metrics_summary.csv" className="btn" style={{border:'1px solid #ddd', borderRadius:'6px', padding:'4px 8px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                            </svg>
                          </CSVLink> */}
                  </div>
                  {loading ? ( // Show loader while loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <div>
                      <Row className="g-2">
                        {/* <Col xxl={2} xl={3} lg={4} sm={6}>
                                <Card className="blush-gradient border-red mb-0 h-100">
                                  <CardBody>
                                    <div className="">
                                      <div className="mb-2">
                                        <p className="f-14 semibold">Assessment Score</p>
                                      </div>
            
                                      <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                        <h4 className="bold">{metricsDataUserPannel ? metricsDataUserPannel.assessmentScore : "Loading"}</h4>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col> */}

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="blush-gradient border-red mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/responedcalls')} style={{ cursor: 'pointer' }}> */}
                          <Card className="peach-blossom-gradient border-yellow mb-0 h-100 ">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    % Students Engaged
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.percentageEngagedOneOnOne
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Students Engaged in 1-1 Sessions (%)
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.percentageEngagedOnPhoneOrVideo
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="lavender-gradient border-lavender mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Average Time Spent in 1:1 Sessions by
                                    Students (Min.)
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.averageTimePerStudent
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="minty-gradient border-green mb-0 h-100 ">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    {' '}
                                    Average Duration Per Session (Min.)
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.averageTimePerCall
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="sky-gradient border-sky mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/teacherlist')} style={{ cursor: 'pointer' }}>
                           */}
                          <Card className="sky-gradient border-sky mb-0 h-100">
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Messages Exchanged Per Student
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {metricsDataUserPannel
                                      ? metricsDataUserPannel.averageMessagesPerStudent
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row className="g-2 mt-1">
                        <Col md={4}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            {loading ? ( // Show loader while loading
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: '200px' }}
                              >
                                <Spinner
                                  style={{ width: '3rem', height: '3rem' }}
                                />
                              </div>
                            ) : (
                              <CardBody>
                                <div className="">
                                  <h5 className="f-16 bold d-flex align-items-center mb-3">
                                    Unit Completion Rate (%)
                                  </h5>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={clusteredColumnChartUnitCompletion(
                                      metricsData,
                                    )}
                                  />
                                </div>
                              </CardBody>
                            )}
                          </Card>
                        </Col>

                        <Col md={4}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            {loading ? ( // Show loader while loading
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: '200px' }}
                              >
                                <Spinner
                                  style={{ width: '3rem', height: '3rem' }}
                                />
                              </div>
                            ) : (
                              <CardBody>
                                <div className="">
                                  <h5 className="f-16 bold d-flex align-items-center mb-3">
                                    Census Melt Rate (%)
                                  </h5>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={clusteredColumnChartCensus(
                                      metricsData,
                                    )}
                                  />
                                </div>
                              </CardBody>
                            )}
                          </Card>
                        </Col>
                        <Col md={4} className="mt-0 mb-md-0 mb-2">
                          <Card className="mb-0 h-100 border box-shadow-none">
                            {loading ? ( // Show loader while loading
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: '200px' }}
                              >
                                <Spinner
                                  style={{ width: '3rem', height: '3rem' }}
                                />
                              </div>
                            ) : (
                              <CardBody>
                                <div className="">
                                  <h5 className="f-16 bold d-flex align-items-center mb-3">
                                    Average Student Satisfaction
                                  </h5>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={barChartOptions}
                                  />
                                </div>
                              </CardBody>
                            )}
                          </Card>
                        </Col>

                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>

              <Card className="mb-2">
                <CardBody>
                  <div className="tab-head d-flex justify-content-between  mb-2"></div>
                  {loading ? ( // Show loader while loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <div>
                      <Row className="g-2">

                        <Col md={12} className="mt-0">
                          <OverView
                            selectedUniversities={appliedUniversities}
                            selectedTimelines={appliedTimelines}
                            selectedTerms={appliedTerms}
                            selectedUnits={appliedUnit}
                            selectedPrograms={appliedPrograms}
                            loading={loading}
                            resetTrigger={resetTrigger}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>

          {/* <SocialSource selectedUniversities={appliedUniversities} selectedTimelines={appliedTimelines} selectedTerms={appliedTerms} selectedUnits={appliedUnit} selectedPrograms={appliedPrograms} /> */}

          <div>
            <Card className="mb-2">
              <CardBody>
                <Row className="g-2 mt-0 mb-0">
                  <Col xl={6} className="mt-0 mb-0">
                    <Card className="mb-0 h-100 border box-shadow-none">
                      {loading ? ( // Show loader while loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                      ) : (
                        <CardBody>
                          <div className="">
                            <h5 className="f-16 bold d-flex align-items-center  mb-3">
                              Message Responsiveness
                            </h5>

                            <HighchartsReact
                              highcharts={Highcharts}
                              options={donutChartOptions1}
                            />
                            <div className="d-flex flex-sm-row flex-column  gap-2 pt-2">
                              <div className="data-card-value dcv-1">
                                <p className="data-val">
                                  {messageResponsiveness['0-1hrs']}
                                </p>
                                <p className="data-label">Within 60 min</p>
                              </div>
                              <div className="data-card-value dcv-2">
                                <p className="data-val">
                                  {messageResponsiveness['1-2hrs']}
                                </p>
                                <p className="data-label">In 1-2 hrs</p>
                              </div>
                              {/* <div className="data-card-value dcv-5">
                            <p className="data-val">{messageResponsiveness["2-3hrs"]}</p>
                            <p className="data-label">In 2-4 hrs</p>
                          </div> */}
                            </div>
                            <div className="d-flex flex-sm-row flex-column gap-2 pt-2">
                              <div className="data-card-value dcv-6">
                                <p className="data-val">
                                  {messageResponsiveness['2-6hrs']}
                                </p>
                                <p className="data-label">In 2-6 hrs</p>
                              </div>
                              <div className="data-card-value dcv-4">
                                <p className="data-val">
                                  {messageResponsiveness.above_6_hrs}
                                </p>
                                <p className="data-label">In More than 6 hrs</p>
                              </div>
                              <div className="data-card-value dcv-3">
                                <p className="data-val">
                                  {messageResponsiveness.not_responded}
                                </p>
                                <p className="data-label">Not Responded</p>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      )}
                    </Card>
                  </Col>
                  <Col md={6} className="mt-0">
                    <Card className="mb-0 h-100 border box-shadow-none">
                      {loading ? ( // Show loader while loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner
                            style={{ width: '3rem', height: '3rem' }}
                          />
                        </div>
                      ) : (
                        <CardBody>
                          <div className="">
                            <h5 className="f-16 bold d-flex align-items-center mb-3">
                              Grading Quality Score
                            </h5>
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={barChartAssessmentScore(
                                assessmentData,
                              )}
                            />
                          </div>
                        </CardBody>
                      )}
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>

          <style scoped>
            {`
        .data-card-value{
          width: 100%;
          padding: 12px;
          border: 1px solid #E8E8E9;
          border-radius: 6px;
        }
        .data-val{
          font-size: 16px;
          font-weight: bold;
          color: #1c1c1c;
        }
        .data-val{
          font-size: 14px;
        }
         .dcv-1{
          position: relative;
        }
        .dcv-1::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(235,255,238,1) 0%, rgba(162,234,179,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-2{
           position: relative;
        }
        .dcv-2::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(183,208,246,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-3{
           position: relative;
        }
        .dcv-3::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
          background: linear-gradient(180deg, rgba(255,210,210,1) 0%, rgba(247,148,150,1) 100%);
      
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-4{
          position: relative;
        }
        .dcv-4::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background:linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(147,151,255,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-5{
           position: relative;
        }
        .dcv-5::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(255,239,225,1) 0%, rgba(255,229,205,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }

        .dcv-6{
           position: relative;
        }
        .dcv-6::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, #96bdc900 0%, #53839299 100%);
        border-radius: 0px 32px 32px 0px;
        }
        
        @media (max-width:1199px) {
          .charts-card{
            display: flex;
            gap: 16px;
          }
        }
        @media (max-width:560px) {
          .charts-card{
            flex-wrap: wrap;
          }
        }
      `}
          </style>

          <Card className="mb-2">
            <CardBody>
              <div className="tab-head d-flex justify-content-between  mb-2">
                <h5 className="bold">1-1 Session Insights</h5>
              </div>
              {Call_performance_response && !loading ? (
                <Row className="g-2">
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      <CardBody>
                        <div className="">
                          <h5 className="f-16 bold d-flex align-items-center mb-3">
                            1-1 Session Quality Score
                          </h5>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={callQualityChartOptions}
                          />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      <PlotBarChart
                        xAxisTitle=""
                        title={' Assessment Discussion (%)'}
                        options={{
                          'Assessment Discussed':
                            Call_performance_response?.assessment_discussed_students,
                        }}
                      />
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      <AssessmentDiscussionDraftChart
                        xAxisTitle=""
                        options={{
                          'Assessment Draft Discussed':
                            Call_performance_response?.draft_discussed_students,
                        }}
                      />
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      {/* <StudentSentimentChart
                        options={
                          Call_performance_response?.weekly_student_sentiments
                        }
                      /> */}

                      <PlotBarChart
                        title="Student Sentiment Score (%)"
                        xAxisTitle="Student Sentiment"
                        yAxisTitle="Avg Student Sentiment Score"
                        barColors={['#a9eb91', '#ffe0b2', '#F79496']}
                        options={Call_performance_response?.student_sentiments}
                      />
                    </Card>
                  </Col>
                </Row>
              ) : (
                <>
                  {loading ? (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner />
                    </Card>
                  ) : (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      No Call Perfomance is available for chosen metrics or
                      Choose different metrics
                    </Card>
                  )}
                </>
              )}
            </CardBody>
          </Card>
          <Card className="mb-2">
            <CardBody>
              <div className="tab-head d-flex justify-content-between  mb-2">
                <h5 className="bold">Group Session Insights</h5>
              </div>
              {Call_performance_response && !loading ? (
                <Row className="g-2">
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      <PlotBarChart
                        yAxisTitle="Quality Score (%)"
                        xAxisTitle=""
                        title={'Group Session Quality Score'}
                        options={{
                          'Average Quality Score':
                            webinar_performance_response?.overall_webinar_quality_score,
                        }}
                      />
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      <PlotBarChart
                        xAxisTitle=""
                        barColors={['#68c0c5']}
                        yAxisTitle="Session Engagement Score"
                        title={'Student Engagement Score'}
                        options={{
                          'Average Session Engagement Score ':
                            webinar_performance_response?.overall_instructor_engagement_score,
                        }}
                      />
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card className="mb-0 h-100 border box-shadow-none">
                      {/* <StudentSentimentChart
                        options={
                          Call_performance_response?.weekly_student_sentiments
                        }
                      /> */}

                      <PlotBarChart
                        title="Student Sentiment Analysis"
                        xAxisTitle="Student Sentiment"
                        yAxisTitle="% Students"
                        barColors={['#a9eb91', '#ffe0b2', '#F79496']}
                        options={
                          webinar_performance_response?.webinar_sentiments
                        }
                      />
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                      <PlotBarChart
                        xAxisTitle=""
                        title="Assessment Discussion in Group Sessions"
                        yAxisTitle="% of Sessions"
                        barColors={['#A2CCFA']}
                        options={{
                          'Assessment Discussions':
                            webinar_performance_response?.students_discussed_assessments,
                        }}
                        suffix="%"
                      />
                    </Card>
                  </Col>
                </Row>
              ) : (
                <>
                  {loading ? (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner />
                    </Card>
                  ) : (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      No Webinar Perfomance is available for chosen metrics or
                      Choose different metrics
                    </Card>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
